<template>
  <div class="meter-transfer-form page">
    <van-nav-bar left-text="返回" :title="$route.meta.title" @click-left="$comm.onClickLeft" v-show="$comm.titleShow()" left-arrow fixed>
      <template #left>
        <span class="iconfont iconshang comm-rotate-270"></span>
        <span class="comm-return">返回</span>
      </template>
    </van-nav-bar>
    <div class="comm-topbar-height" v-show="$comm.titleShow()"></div>

    <van-form @submit="onSubmit" :validate-trigger="$trigger" v-show="active1 == 0" class="van-form-without-tab">
      <van-cell-group title="申请信息">
        <van-field required v-model="form.foper" label="联系人" placeholder="请输入联系人" :rules="[{ required: true, message: '请输入联系人' }]" />
        <van-field required :rules="[{ required: true, message: '请输入检测地址' }]" v-model="form.faddr" label="检测地址" placeholder="请输入检测地址" />
        <van-field required v-model="form.fopermobile" name="validator" label="手机号码" placeholder="请输入" @change="nameChange()" :rules="[{ pattern: $pattern, message: '请输入手机号码' }]" />
        <van-field v-show="falg" required v-model="form.smscode" center clearable label="短信验证" placeholder="请输入短信验证">
          <template #button>
            <sms-btn :phone="form.fopermobile"></sms-btn>
          </template>
        </van-field>
        <van-field required :rules="[{ required: true, message: '请输入说明' }]" v-model="form.fnetcontent" rows="2" autosize label="说明" type="textarea" maxlength="300" placeholder="请输入说明" show-word-limit />
      </van-cell-group>

      <yonghuxuzhi v-show="falg" @changeChecked="changeChecked" :typecode="typecode" :ftrantype="1"></yonghuxuzhi>

      <van-button v-show="falg" :disabled="!checked" block type="info" native-type="submit">
        提交
      </van-button>
    </van-form>

  </div>
</template>

<script>
import smsBtn from '@/components/smsBtn.vue'

export default {
  name: 'MeterTransferForm',
  components: {
    smsBtn
  },
  data() {
    return {
      typecode: 221,
      active1: 0,
      form: {
        fsou: this.$comm.titleShow() ? 2 : 4,
        foper: "",
        fopermobile: "",
        faddr: "",
        smscode: '',
        fnetcontent: ''
      },
      falg: this.$route.query.busstype ? false : true,
      checked: false
    }
  },
  mounted() {
    if (!this.falg) {
      this.info()
    }
  },
  methods: {
    changeChecked(checked) {
      this.checked = checked
    },
    nameChange() {

    },
    // 查询详情
    info() {
      this.$http.post(this.$api.serviceinfo, {
        busstype: this.$route.query.busstype,
        bussno: this.$route.query.bussno
      }).then(res => {
        if (res.code === '000') {
          this.form = res.data
          this.$clear()
        } else {
          this.$toast(res.msg)
        }
      })
    },
    onSubmit() {
      this.$http.post(this.$api.serviceCheck, this.form).then(res => {
        if (res.code === '000') {
          this.$router.push({
            path: '/business/success',
            query: {
              title: this.$route.meta.title,
              from: '水管家服务',
              path: '/mine/shuizhijiancebaogao'
            }
          })
        } else {
          this.$toast(res.msg)
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.meter-transfer-form {
  /deep/ .van-radio-group.van-radio-group--horizontal {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(33, 33, 33, 1);

    .van-radio--horizontal {
      margin-right: 0;
      margin-left: 4px;

      .van-radio__label {
        margin-left: 2px;
      }
    }
  }

  .form-pop {
    width: 85%;
    height: 60%;
    border-radius: 4px;
    font-size: 12px;
  }
}
</style>